import { render, staticRenderFns } from "./DetailedAccounts.vue?vue&type=template&id=aecb98fc&scoped=true"
import script from "./DetailedAccounts.vue?vue&type=script&lang=js"
export * from "./DetailedAccounts.vue?vue&type=script&lang=js"
import style0 from "./DetailedAccounts.vue?vue&type=style&index=0&id=aecb98fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecb98fc",
  null
  
)

export default component.exports